// extracted by css-extract-rspack-plugin
export default {"title":"title-OzdzS5","disclaimer-text":"disclaimer-text-knoLAJ","disclaimerText":"disclaimer-text-knoLAJ"};